<template>
  <div class="lby-gossip-item" @click="gossipInfo">
    <h2>标题</h2>
    <div class="lby-gossip-title">{{showTitle}}</div>
    <div class="lby-gossip-createTime">{{gossip.createTime}}</div>
  </div>
</template>

<script>
export default {
  name: 'UCGossip',
  props: ['gossip'],
  computed: {
    showTitle () {
      if (this.gossip.title.length <= 66) {
        return this.gossip.title
      }
      return this.gossip.title.substring(0, 65) + '...'
    }
  },
  methods: {
    gossipInfo () {
      this.$router.push({
        path: '/gossipinfo',
        query: {
          gossipId: this.gossip.id
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.lby-gossip-item{
    width: 150px;
    height: 100%;
    border-radius: 10px;
    border: 1px solid #409eff;
    box-shadow: 0 0 4px rgb(53, 52, 52);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .lby-gossip-title{
        white-space: wrap;
        text-align: left;
        height: 100px;
        padding-left: 4px;
        padding-right: 4px;
        overflow: hidden;
        font-family: 'Courier New', Courier, monospace;
    }
}
.lby-gossip-item:hover{
    border-color: red;
    cursor: pointer;
}
</style>
